import { render, staticRenderFns } from "./PageSetting.vue?vue&type=template&id=b6253086&scoped=true&"
import script from "./PageSetting.vue?vue&type=script&lang=js&"
export * from "./PageSetting.vue?vue&type=script&lang=js&"
import style0 from "./PageSetting.vue?vue&type=style&index=0&id=b6253086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6253086",
  null
  
)

export default component.exports